const ACFBlockHeroFilm = (domEl) => {

	const filmEl = domEl.querySelector('.film');
	const videoSrc = filmEl.getAttribute('data-src');
	if(!videoSrc) {
		return;
	}

	const objectPositionX = filmEl.getAttribute('data-object-position-x') ? filmEl.getAttribute('data-object-position-x') : 50;
	const objectPositionY = filmEl.getAttribute('data-object-position-y') ? filmEl.getAttribute('data-object-position-y') : 50;

	// Append video and autoplay
	const videoEl = document.createElement('video');
	videoEl.src = videoSrc;
	videoEl.playsInline = true;
	videoEl.controls = false;
	videoEl.muted = true;
	videoEl.autoplay = true;
	videoEl.loop = true;
	videoEl.style.objectPosition = `${objectPositionX}% ${objectPositionY}%`;
	filmEl.appendChild(videoEl);
	filmEl.classList.add('js-video-added');
};

export default ACFBlockHeroFilm;